import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createSmartOutbound, getProductStockInfo } from '../../actions/inventoryActions';

const SmartOutbound = () => {
    const dispatch = useDispatch();
    const [outboundItems, setOutboundItems] = useState([
        { product_id: '', type: 'unit', quantity: 1, unit_price: 0 }
    ]);
    const [customer, setCustomer] = useState('');
    const [operator, setOperator] = useState('');
    const [notes, setNotes] = useState('');
    const [warehouse_id, setWarehouseId] = useState('');
    const [stockInfo, setStockInfo] = useState({});
    const [loading, setLoading] = useState(false);

    // 添加出库项目
    const addOutboundItem = () => {
        setOutboundItems([
            ...outboundItems,
            { product_id: '', type: 'unit', quantity: 1, unit_price: 0 }
        ]);
    };

    // 删除出库项目
    const removeOutboundItem = (index) => {
        if (outboundItems.length > 1) {
            setOutboundItems(outboundItems.filter((_, i) => i !== index));
        }
    };

    // 更新出库项目
    const updateOutboundItem = (index, field, value) => {
        const updatedItems = [...outboundItems];
        updatedItems[index][field] = value;
        setOutboundItems(updatedItems);

        // 如果更新了产品ID，获取库存信息
        if (field === 'product_id' && value) {
            fetchStockInfo(value);
        }
    };

    const fetchStockInfo = async (productId) => {
        try {
            const data = await dispatch(getProductStockInfo(productId, warehouse_id));
            setStockInfo(prev => ({
                ...prev,
                [productId]: data
            }));
        } catch (error) {
            console.error('获取库存信息失败:', error);
        }
    };

    // 提交出库
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const outboundData = {
                items: outboundItems.filter(item => item.product_id && item.quantity > 0),
                customer,
                operator,
                notes,
                warehouse_id: warehouse_id || undefined
            };

            const result = await dispatch(createSmartOutbound(outboundData));
            
            alert(`出库成功！共处理 ${result.total_units_processed} 个单位`);
            
            // 重置表单
            setOutboundItems([{ product_id: '', type: 'unit', quantity: 1, unit_price: 0 }]);
            setCustomer('');
            setNotes('');
            setStockInfo({});
            
        } catch (error) {
            alert(`出库失败: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="smart-outbound">
            <h3>智能出库</h3>
            
            <form onSubmit={handleSubmit}>
                {/* 基本信息 */}
                <div className="form-section">
                    <h4>基本信息</h4>
                    <div className="form-row">
                        <input
                            type="text"
                            placeholder="客户名称"
                            value={customer}
                            onChange={(e) => setCustomer(e.target.value)}
                            required
                        />
                        <input
                            type="text"
                            placeholder="操作员"
                            value={operator}
                            onChange={(e) => setOperator(e.target.value)}
                            required
                        />
                        <select
                            value={warehouse_id}
                            onChange={(e) => setWarehouseId(e.target.value)}
                        >
                            <option value="">所有仓库</option>
                            {/* 这里需要从state获取仓库列表 */}
                        </select>
                    </div>
                </div>

                {/* 出库项目 */}
                <div className="form-section">
                    <h4>出库项目</h4>
                    {outboundItems.map((item, index) => (
                        <div key={index} className="outbound-item">
                            <input
                                type="number"
                                placeholder="产品ID"
                                value={item.product_id}
                                onChange={(e) => updateOutboundItem(index, 'product_id', e.target.value)}
                                required
                            />
                            
                            <select
                                value={item.type}
                                onChange={(e) => updateOutboundItem(index, 'type', e.target.value)}
                            >
                                <option value="unit">散装</option>
                                <option value="box">整箱</option>
                            </select>
                            
                            <input
                                type="number"
                                placeholder="数量"
                                min="1"
                                value={item.quantity}
                                onChange={(e) => updateOutboundItem(index, 'quantity', parseInt(e.target.value))}
                                required
                            />
                            
                            <input
                                type="number"
                                placeholder="单价（可选）"
                                step="0.01"
                                value={item.unit_price}
                                onChange={(e) => updateOutboundItem(index, 'unit_price', parseFloat(e.target.value))}
                            />

                            {/* 显示库存信息 */}
                            {stockInfo[item.product_id] && (
                                <div className="stock-info">
                                    <small>
                                        可用整箱: {stockInfo[item.product_id].stock_summary.total_available_boxes} |
                                        可用散装: {stockInfo[item.product_id].stock_summary.total_available_units}
                                    </small>
                                </div>
                            )}
                            
                            <button
                                type="button"
                                onClick={() => removeOutboundItem(index)}
                                disabled={outboundItems.length <= 1}
                            >
                                删除
                            </button>
                        </div>
                    ))}
                    
                    <button type="button" onClick={addOutboundItem}>
                        添加项目
                    </button>
                </div>

                {/* 备注 */}
                <div className="form-section">
                    <textarea
                        placeholder="备注"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows="3"
                    />
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? '处理中...' : '确认出库'}
                </button>
            </form>
        </div>
    );
};

export default SmartOutbound;